import { Injectable, NgZone } from "@angular/core";
import { Driver, NgForage, NgForageConfig } from "ngforage";
import { LogService } from "../log/log.service";
import { LocalstorageHelper } from "./localstorage-helper";
import { EnvironmentConfiguration } from '@nts/std/environments';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {

    private initialized = false;
    private initPromise: Promise<void> | null = null;

    constructor(
        private ngfConfig: NgForageConfig,
        private zone: NgZone,
        private env: EnvironmentConfiguration,
        private ngf: NgForage
    ) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.init();
    }

    async init() {
        if (this.initialized) {
            return;
        }

        if (this.initPromise != null) {
            await this.initPromise;
            return;
        }

        this.initPromise = this.doInit();

        try {
            await this.initPromise;
            this.initialized = true;
        } finally {
            this.initPromise = null;
        }
    }

    private async doInit(): Promise<void> {
        this.ngfConfig.configure({
            name: this.env.appTitle,
            driver: [ // defaults to indexedDB -> webSQL -> localStorage
                Driver.INDEXED_DB,
                Driver.LOCAL_STORAGE
            ]
        });
        const inIframe = window.self != window.top;
        LogService.debug(`${window.location.href} - inIframe: ${inIframe}`);
        await LocalstorageHelper.init(this.zone, inIframe, this.ngf, this.env);
    }
}
